import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  // modules: { finish, picture, photo, video, goods, setting, menus },
  state: {
    // 加载状态
    resLoading: true,
    // 面包屑
    breadcrumb: [],
    // 筛选框伸缩
    stretchSwitch: false,
    // 表格监听状态
    tableWatch: false,
    // 按钮状态
    btnLoad: [{value: false}, {value: false}, {value: false}, {value: false}, {value: false}, {value: false}, {value: false}, {value: false}, {value: false}, {value: false}],
    screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
    menuState: true // true => 展开
  },
  mutations: {
    updateScreenHeight (state, value) {
      state.screenHeight = value
    },
    updateMenuState (state, e) {
      state.menuState = e
    },
    // 更新加载状态
    updateLoading (state, e) {
      Vue.set(state, 'resLoading', e)
    },
    // 更新面包屑
    updateBreadcrumb (state, e) {
      Vue.set(state, 'breadcrumb', e)
    },
    // 筛选框伸缩
    updateStretchSwitch (state, e) {
      Vue.set(state, 'stretchSwitch', e)
    },
    // 列表加载
    updateTableWatch (state, e) {
      Vue.set(state, 'tableWatch', e)
    },
    // 按钮状态
    updateBtnLoad (state, e) {
      if (e.bool) {
        state.btnLoad[e.index].value = e.bool
      } else {
        // 延迟关闭
        setTimeout(() => {
          state.btnLoad[e.index].value = e.bool
        }, 1000)
      }
    }
  },
  actions: {

  }
  // getters: getters
})



// WEBPACK FOOTER //
// ./src/store/index.js